import React, { useContext } from 'react';
import { last } from 'ramda';
import { StyledBodyRow } from '../body-row/styled';
import { StyledCell } from '../body-cell/styled';
import { CellPlaceholder } from './styled';
import { NewCheckbox } from '../../../checkbox/checkbox';
import { TableSettingsContext } from '../../table-settings-context';
const LOADING_ROWS_COUNT = 3;
export const TableLoading = ({ headerGroups }) => {
    const { checkboxType } = useContext(TableSettingsContext);
    const lastHeaderGroup = last(headerGroups);
    return (React.createElement(React.Fragment, null, lastHeaderGroup &&
        Array(LOADING_ROWS_COUNT)
            .fill(null)
            .map((_, i) => {
            const className = `invent-table-row ${i % 2 ? 'odd' : 'even'}`;
            return (React.createElement(StyledBodyRow, { key: i, className: className }, lastHeaderGroup.headers.map((h) => {
                const header = h;
                const isSelection = header.id === 'selection';
                return (React.createElement(StyledCell, { key: header.id, className: isSelection ? 'invent-table-select' : '' }, isSelection ? (React.createElement(NewCheckbox, { checked: false, onChange: () => null, filled: checkboxType === 'filled' })) : (React.createElement("div", { className: header.headerEndAlight ? 'align-end' : '' },
                    React.createElement(CellPlaceholder, null, header.columnName)))));
            })));
        })));
};
